import React from 'react';
import { Check, Minus } from 'lucide-react';
import { foundationsComparison as c } from '../../data/programDetails';

export default function PhilosophyComparison() {
  return (
    <section className="py-20 bg-splash-green text-splash-cream" data-testid="foundations-philosophy">
      <div className="max-w-6xl mx-auto px-6">
        <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">Our Philosophy</div>
        <h2 className="font-display font-bold text-3xl md:text-5xl text-white leading-tight max-w-3xl">How Little Splash Foundations™ compares to other popular programs</h2>
        <p className="mt-6 max-w-3xl text-base md:text-lg leading-relaxed text-splash-cream/85">{c.intro}</p>
        <div className="mt-10 rounded-3xl overflow-hidden border border-white/10">
          <div className="hidden md:grid grid-cols-[180px_1fr_1fr] bg-white/5 text-xs uppercase tracking-widest font-semibold">
            <div className="p-4" />
            <div className="p-4 text-splash-cream/60">ISR &amp; similar intensive programs</div>
            <div className="p-4 text-splash-coral">Little Splash Foundations™</div>
          </div>
          {c.rows.map((r, i) => (
            <div key={r.topic} data-testid={`comparison-row-${i}`} className="grid md:grid-cols-[180px_1fr_1fr] border-t border-white/10 first:border-t-0 md:first:border-t">
              <div className="p-4 font-semibold text-white">{r.topic}</div>
              <div className="px-4 pb-3 md:p-4 text-sm text-splash-cream/70 flex gap-2">
                <Minus className="w-4 h-4 shrink-0 mt-0.5 text-splash-cream/40" />
                <span><span className="md:hidden font-semibold text-splash-cream/60">ISR &amp; similar: </span>{r.other}</span>
              </div>
              <div className="px-4 pb-4 md:p-4 text-sm text-white flex gap-2 md:bg-white/5">
                <Check className="w-4 h-4 shrink-0 mt-0.5 text-splash-coral" />
                <span><span className="md:hidden font-semibold text-splash-coral">Little Splash Foundations™: </span>{r.ours}</span>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-4 text-xs text-splash-cream/55">{c.note}</p>
      </div>
    </section>
  );
}
